__turbopack_context__.v({
  "app_light_theme": "category-item-module-scss-module__iS-Saq__app_light_theme",
  "emptyImage": "category-item-module-scss-module__iS-Saq__emptyImage",
  "imageWrap": "category-item-module-scss-module__iS-Saq__imageWrap",
  "root": "category-item-module-scss-module__iS-Saq__root",
  "title": "category-item-module-scss-module__iS-Saq__title",
});
